import { atom } from "recoil"
import localStorageEffect from "../libs/localStorageEffect"

const currentAssociation = atom({
  key: "association_state",
  default: {
    id: "",
    address: "",
    beta: true,
    city: "",
    state: "",
    country: "",
    createdAt: "",
    email: "",
    image: "",
    location: {
      placeid: "",
      lat: "",
      lng: "",
    },
    name: "",
    phone: "",
    postalCode: "",
    url: "",
  },
  effects_UNSTABLE: [localStorageEffect("association_state")],
})

export default currentAssociation
